import type { DecodedJwt } from '@newfront-insurance/next-auth-api-types';

export function parseTokenPayload<T>(token: string): T {
  const [, payload] = token.split('.');
  if (!payload) {
    throw new Error('Invalid JWT: missing payload segment');
  }
  // JWTs are base64url-encoded (`-`, `_`, and no padding), but atob only accepts
  // standard base64. Normalize first, otherwise any payload containing url-safe
  // characters throws InvalidCharacterError.
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  const payloadStr = atob(padded);
  return JSON.parse(payloadStr) as T;
}

export function isTokenExpired(token?: string): boolean {
  if (!token) return true;
  const payload = parseTokenPayload<DecodedJwt>(token);
  return payload.exp * 1000 <= Date.now();
}
